// extracted by mini-css-extract-plugin
export default {"link":"S23VEJ"};